export const toDollars = (value: number | null | undefined) => {
  if (value != null) {
    return Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(value / 100)
  }
}
